import {
    EmploymentGuaranteeType,
    MarketResearchFeature,
    JobPriorityType,
    UserRole,
} from "@relode/core/domain";
import { AddJobStep3Details } from "../../types";
import { JobPendingStepThreeResponse } from "../controllers/jobs";

export const convertAddJobStep3DetailsResponse = (
    response: JobPendingStepThreeResponse
) => {
    if (!response) return null;

    const step3Details: AddJobStep3Details = {
        jobId: response.jobId,
        jobLocationName: response.jobLocationName,
        planName: response.planName,
        postingFeeInUSDollars: response.postingFeeInUSDollars,
        employmentGuarantee: EmploymentGuaranteeType.fromId(
            response.employmentGuaranteeTypeId
        ),
        jobPriorityType: JobPriorityType.fromId(response.jobPriorityTypeId),
        quantity: response.quantity,

        successFeePercentage: response.successFeePercentage,
        successFeeInUSDollars: response.successFeeInUSDollars,
        successFeeSavingsInUSDollars: response.successFeeSavingsInUSDollars,
        defaultPostingFeeInUSDollars: response.defaultPostingFeeInUSDollars,
        marketResearchFeatureType: MarketResearchFeature.fromId(
            response.marketResearchFeatureTypeId
        ),

        defaultJobPriorityASuccessFeePercentage:
            response.defaultJobPriorityASuccessFeePercentage,
        defaultJobPriorityBSuccessFeePercentage:
            response.defaultJobPriorityBSuccessFeePercentage,
        defaultJobPriorityCSuccessFeePercentage:
            response.defaultJobPriorityCSuccessFeePercentage,
        defaultJobPriorityDSuccessFeePercentage:
            response.defaultJobPriorityDSuccessFeePercentage,
        estimatedDefaultJobPriorityASuccessFeeInUSDollars:
            response.estimatedDefaultJobPriorityASuccessFeeInUSDollars,
        estimatedDefaultJobPriorityBSuccessFeeInUSDollars:
            response.estimatedDefaultJobPriorityBSuccessFeeInUSDollars,
        estimatedDefaultJobPriorityCSuccessFeeInUSDollars:
            response.estimatedDefaultJobPriorityCSuccessFeeInUSDollars,
        estimatedDefaultJobPriorityDSuccessFeeInUSDollars:
            response.estimatedDefaultJobPriorityDSuccessFeeInUSDollars,
        estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars:
            response.estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars,
        estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars:
            response.estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars,
        estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars:
            response.estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars,
        estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars:
            response.estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars,

        billRateInUSDollars: response.billRateInUSDollars,
        estimatedContractBillTotalInUSDollars:
            response.estimatedContractBillTotalInUSDollars,
        estimatedContractBillTotalSavingsInUSDollars:
            response.estimatedContractBillTotalSavingsInUSDollars,

        hasSignedAgreement: response.hasSignedAgreement,
        jobSalaryInUSDollars: response.jobSalaryInUSDollars,
        contractStartDate: response.contractStartDate,
        contractEndDate: response.contractEndDate,
        hoursPerWeek: response.hoursPerWeek,

        jobManagerUserId: response.jobManagerUserId,
        jobManagerFullName: response.jobManagerFullName,
        jobManagerRoleType: UserRole.fromId(response.jobManagerRoleTypeId),
        jobConcurrencyToken: response.jobConcurrencyToken,
    };
    return step3Details;
};
